import React from 'react';

import styles from './InputTemplateBadge.module.scss';
import TemplateIcon from '@lmt/unicorn-shared/app/icons/template.svg?react';

interface Props {
  onClick: () => void;
  isSelected: boolean;
}

export const InputTemplateBadge = (props: Props) => {
  return (
    <TemplateIcon
      className={styles.templateIcon}
      onClick={props.onClick}
      data-test-id="templateIcon"
      data-selected={props.isSelected}
    />
  );
};
